import { render, staticRenderFns } from "./PublicationSliderGallery.vue?vue&type=template&id=e25cc57c&scoped=true&"
import script from "./PublicationSliderGallery.vue?vue&type=script&lang=js&"
export * from "./PublicationSliderGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25cc57c",
  null
  
)

export default component.exports